import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {
  private lastRegionId = new BehaviorSubject<string | null>(null);
  private lastAssetId = new BehaviorSubject<string | null>(null);

  lastRegionId$ = this.lastRegionId.asObservable();
  lastAssetId$ = this.lastAssetId.asObservable();

  setRegionId(id: string) {
    this.lastRegionId.next(id);
    localStorage.setItem('lastRegionId', id);
  }

  setAssetId(id: string) {
    this.lastAssetId.next(id);
    localStorage.setItem('lastAssetId', id);
  }

  getCurrentRegionId(): string | null {
    return this.lastRegionId.getValue();
  }

  getCurrentAssetId(): string | null {
    return this.lastAssetId.getValue();
  }

  constructor() {
    const savedRegionId = localStorage.getItem('lastRegionId');
    const savedAssetId = localStorage.getItem('lastAssetId');
    
    if (savedRegionId) {
      this.lastRegionId.next(savedRegionId);
    }
    if (savedAssetId) {
      this.lastAssetId.next(savedAssetId);
    }
  }

  clearState() {
    this.lastRegionId.next(null);
    this.lastAssetId.next(null);
    localStorage.removeItem('lastRegionId');
    localStorage.removeItem('lastAssetId');
  }
}
